// React Dependencies
import React, { useState, useEffect } from 'react';

// External Dependenciesx
import { Button, List, ListItem, TextField, makeStyles } from '@material-ui/core';
import { toast } from 'react-toastify';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// Internal Dependencies
import MapTable from './table';
import { getPagesByParams, updateMallMapPageStatus } from '../../actions/admin/pageAction';
import Constants from '../../common/constants';

const useStyles = makeStyles(() => ({
  searchInput: {
    width: '100%',
  },
  listContainer: {
    height:    '70vh',
    overflowY: 'scroll',
  },
  listItem: {
    fontSize:     '16px',
    border:       '1px solid #ccc',
    borderRadius: '5px',
    marginBottom: '4px',
    cursor:       'pointer',

    '&:hover': {
      backgroundColor: '#ccc',
    },
  },
}));

const MapListing = () => {
  const classes = useStyles();

  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchName, setSearchName] = useState('');
  const [pages, setPages] = useState([]);

  const filteredPages = [];
  pages.forEach((page) => {
    if (page.name.toLowerCase().indexOf(searchName.toLowerCase()) !== -1) {
      filteredPages.push(page);
    }
  });

  const toggle = () => setShowModal(!showModal);

  const addMallMapHandler = async (page) => {
    try {
      await updateMallMapPageStatus(page.id, Constants.Status.Draft);
      toast.success('Mall map page added');
      toggle();
    } catch (err) {
      toast.error(err.message);
      console.log(err);
    }
  };

  const fetchPages = async () => {
    try {
      setIsLoading(true);
      setPages([]);

      const response = await getPagesByParams({ types: [Constants.PageType.Mall], mallMapStatus: Constants.Status.Pending, pageSize: 1000  })();
      setPages(response.rows || []);
      setSearchName('');
    } catch (err) {
      toast.error(err.message);
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (showModal) {
      fetchPages();
    }
  }, [showModal]);

  return (
    <>
      <div className="content-header">
        <h1>Mall Maps</h1>
        <Button variant="contained" onClick={toggle}>Add</Button>
      </div>
      <MapTable />

      <Modal isOpen={showModal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Add Mall Map</ModalHeader>
        <ModalBody>
          <TextField
            id="search-mallmap-pages"
            className={classes.searchInput}
            label="Search"
            variant="outlined"
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
          />

          { isLoading ? <p>Loading...</p>
            : (
              <List className={classes.listContainer}>
                { filteredPages.map((page) => (
                  <ListItem
                    key={page.id}
                    className={classes.listItem}
                    onClick={() => addMallMapHandler(page)}
                  >
                    {page.name}
                  </ListItem>
                )) }
              </List>
            )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default MapListing;
